import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { useFeature } from '@optimizely/react-sdk';
import { useHistory } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import { theme } from '../theme';
import { MobileStripV2 } from './MobileStrip';
import { DesktopStripV2 } from './DesktopStrip';
export var ActionStripV2 = function ActionStripV2(props) {
  var history = useHistory();
  var _props$mobileOverride = props.mobileOverrides,
      mobileOverrides = _props$mobileOverride === void 0 ? {} : _props$mobileOverride,
      onBack = props.onBack,
      preventDefault = props.preventDefault;

  var _useFeature = useFeature('side_bottom_nav'),
      _useFeature2 = _slicedToArray(_useFeature, 1),
      isSBNavEnabled = _useFeature2[0];

  var handleOnBack = function handleOnBack() {
    if (onBack) {
      onBack();
    }

    if (!preventDefault) {
      history.goBack();
    }
  };

  var desktopProps = _objectSpread(_objectSpread({}, props), {}, {
    onBack: handleOnBack,
    isSBNavEnabled: isSBNavEnabled
  });

  var mobileProps = _objectSpread(_objectSpread(_objectSpread({}, props), mobileOverrides), {}, {
    onBack: handleOnBack,
    isSBNavEnabled: isSBNavEnabled
  });

  var isMobile = useMediaQuery({
    query: "(max-width: ".concat(theme.breakpoints.sm, "px)")
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, isMobile ? /*#__PURE__*/React.createElement(MobileStripV2, mobileProps) : /*#__PURE__*/React.createElement(DesktopStripV2, desktopProps));
};